import _ from 'lodash';
import PublicEnv from 'shared/utils/public-env';
var amplitudeClient = {
    init: _.noop,
    logEvent: _.noop,
    setUserId: _.noop,
    setUserProperties: _.noop
};
// we need to prevent import on the serverside
if (typeof window !== 'undefined') {
// NOOP - Amplitude support removed on 7/15/24.
// Keeping this file because the events are helpful and will likely be sent elsewhere
}
var setupAmplitude = _.once(function() {
// NOOP - Amplitude support removed on 7/15/24.
// Keeping this file because the events are helpful and will likely be sent elsewhere
});
export var getCartEventProperties = function(Cart, UI) {
    var _Cart_costBreakdown, _Cart_order_appliedRewards, _Cart_order, _Cart_order1, _Cart_costBreakdown1, _Cart_order2, _Cart_dispensary, _Cart_dispensary1;
    var _Cart_costBreakdown_total;
    return {
        orderTotal: ((_Cart_costBreakdown_total = Cart === null || Cart === void 0 ? void 0 : (_Cart_costBreakdown = Cart.costBreakdown) === null || _Cart_costBreakdown === void 0 ? void 0 : _Cart_costBreakdown.total) !== null && _Cart_costBreakdown_total !== void 0 ? _Cart_costBreakdown_total : 0).toFixed(2),
        rewardRedemption: !!((Cart === null || Cart === void 0 ? void 0 : (_Cart_order = Cart.order) === null || _Cart_order === void 0 ? void 0 : (_Cart_order_appliedRewards = _Cart_order.appliedRewards) === null || _Cart_order_appliedRewards === void 0 ? void 0 : _Cart_order_appliedRewards.length) > 0),
        couponRedemption: !!(Cart === null || Cart === void 0 ? void 0 : (_Cart_order1 = Cart.order) === null || _Cart_order1 === void 0 ? void 0 : _Cart_order1.coupon),
        saleRedemption: (Cart === null || Cart === void 0 ? void 0 : (_Cart_costBreakdown1 = Cart.costBreakdown) === null || _Cart_costBreakdown1 === void 0 ? void 0 : _Cart_costBreakdown1.credit) > 0,
        paymentType: Cart === null || Cart === void 0 ? void 0 : (_Cart_order2 = Cart.order) === null || _Cart_order2 === void 0 ? void 0 : _Cart_order2.paymentMethod,
        dispensaryId: Cart === null || Cart === void 0 ? void 0 : (_Cart_dispensary = Cart.dispensary) === null || _Cart_dispensary === void 0 ? void 0 : _Cart_dispensary.id,
        dispensaryName: Cart === null || Cart === void 0 ? void 0 : (_Cart_dispensary1 = Cart.dispensary) === null || _Cart_dispensary1 === void 0 ? void 0 : _Cart_dispensary1.name,
        menuVariant: UI.analyticsMenuVariant
    };
};
export var AmplitudeCategory = Object.freeze({
    menu: 'Menu',
    checkout: 'Checkout',
    paymentsMoneris: 'Payments-Moneris',
    paymentsMerrco: 'Payments-Merrco',
    paymentChase: 'Payments-Chase'
});
export var AmplitudeEvents = {
    checkout: {
        placeOrder: "Place Order",
        clickSave: "Click Save",
        goToCheckout: "Go to Checkout",
        createAccount: "Create Account"
    },
    payments: {
        // nesting this assuming there will be other payment modals
        moneris: {
            onSave: "User clicks save",
            onError: "Invalid input"
        }
    },
    menu: {
        viewHomepage: "View Homepage",
        viewCategory: "View a Category Page",
        viewBrand: "View Brand Page",
        viewProduct: "View Product Detail Page",
        addToCart: "Add to Cart",
        quickAdd: "Add to Cart - Quick Add",
        viewSpecials: "View Specials Page",
        clickedIndividualCannabinoid: 'Clicked Individual Cannabinoid'
    }
};
export var AmplitudePaymentFormEventDescriptions = {
    moneris: {
        onSaveSuccess: 'Save Card Info: Success',
        onError: 'Save Card Info: Fail - '
    }
};
export function useAmplitude() {
    setupAmplitude();
    function log(event, data) {
        amplitudeClient.logEvent(event, data);
    }
    return {
        log: log
    };
}
